import {Pipe, PipeTransform} from '@angular/core';
import {RouteService} from '../services/route.service';

@Pipe({
    name: 'vehicleModel'
})
export class VehicleModelPipe implements PipeTransform {
    constructor(private routeService: RouteService) {}

    transform(id: number): any {
        const vehicles = this.routeService.getVehicles();
        return vehicles.filter(user => user.id === id)[0].model;
    }
}
